import { render, staticRenderFns } from "./messageContent.vue?vue&type=template&id=bbbf49d0&scoped=true"
import script from "./messageContent.vue?vue&type=script&lang=js"
export * from "./messageContent.vue?vue&type=script&lang=js"
import style0 from "./messageContent.vue?vue&type=style&index=0&id=bbbf49d0&prod&lang=less&scoped=true"
import style1 from "./messageContent.vue?vue&type=style&index=1&id=bbbf49d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf49d0",
  null
  
)

export default component.exports